var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"c-f-ar bt",on:{"click":_vm.cusClick}},[_vm._v(_vm._s(_vm.t || _vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }